exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Pour Firefox */\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n", ""]);

// exports
